import { cn } from '@/lib/cn'

/**
 * Ce qu'une table ou une formule contient, en liste à puces.
 *
 * La composition était écrite en une seule ligne, séparée par des points
 * médians : « 3 × Softdrink · Eau · 2 bouteilles au choix ». Passé trois
 * éléments, on ne distingue plus ce qui est compris de ce qui ne l'est pas —
 * et c'est précisément ce que le client cherche à savoir avant de payer.
 *
 * Une puce par ligne, chacune alignée sur sa marque : on compte d'un coup
 * d'œil.
 */
export function IncludedList({
  label,
  items,
  className,
}: {
  label: string
  items: string[]
  className?: string
}) {
  if (items.length === 0) return null

  return (
    <div className={cn('text-sm', className)}>
      <p className="text-content-muted">{label}</p>
      <ul className="mt-1.5 space-y-1">
        {items.map((item) => (
          <li key={item} className="flex gap-2 text-content-secondary">
            {/* La puce est décorative : un lecteur d'écran annonce déjà une
                liste, il n'a pas besoin qu'on lui lise « point ». */}
            <span aria-hidden className="mt-[0.45em] h-1 w-1 shrink-0 rounded-full bg-champagne-400" />
            <span className="min-w-0">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
